<script setup lang="ts">
  import {
    sidePanelSkeletonContainerClass,
    sidePanelContentClass,
    sidePanelHeaderClass,
    sidePanelFooterClass,
  } from './SidePanelSkeleton.css';
</script>

<template>
  <div :class="sidePanelSkeletonContainerClass">
    <div :class="sidePanelHeaderClass"><slot name="header" /></div>
    <div :class="sidePanelContentClass"><slot /></div>

    <div :class="sidePanelFooterClass"><slot name="footer" /></div>
  </div>
</template>
